define('modules/image-slider', [
    'domReady',
    'jquery',
    'underscore'
],  function (domReady, $, _) {
    'use strict';

    console.log('%cfile: image-slider.js', 'color: #C2ECFF');

    /** private */
    var _this;
    var _defaults = {
        elements: {
            'viewer': '[data-image-slider]',
            'slides': '[data-image-slider-slide]',
            'previous': '[data-image-slider-previous]',
            'next': '[data-image-slider-next]',
        },
        $elements: {},
        isAnimate: false
    };

    /** constructor */
    function Module(){
        console.log('%ctrace: ImageSlider -> constructor', 'color: #ccc');

        /** public */
        _this = this;

        domReady(function () {
            console.log('%ctrace: ImageSlider -> constructor -> domReady', 'color: #ccc');

            domElementsUpdates();

            $('body').off('click', _defaults.elements.previous).on('click', _defaults.elements.previous, function(e){
                e.preventDefault();

                var curent = _defaults.$elements.slides.index(_defaults.$elements.slides.filter('.previous'));
                _defaults.action = 'previous';
                update(curent);
            });

            $('body').off('click', _defaults.elements.next).on('click', _defaults.elements.next, function(e){
                e.preventDefault();

                var curent = _defaults.$elements.slides.index(_defaults.$elements.slides.filter('.next'));
                _defaults.action = 'next';
                update(curent);
            });

            $('body').off('click', '[data-image-slider-slide].previous').on('click', '[data-image-slider-slide].previous', function(e){
                e.preventDefault();

                var curent = _defaults.$elements.slides.index(_defaults.$elements.slides.filter('.previous'));
                _defaults.action = 'previous';
                update(curent);
            });

            $('body').off('click', '[data-image-slider-slide].next').on('click', '[data-image-slider-slide].next', function(e){
                e.preventDefault();

                var curent = _defaults.$elements.slides.index(_defaults.$elements.slides.filter('.next'));
                _defaults.action = 'next';
                update(curent);
            });
        });
    }

    function domElementsUpdates(){
        console.log('%ctrace: ImageSlider -> domElementsUpdates', 'color: #ccc');

        _.forEach(_defaults.elements, function(value, key){
            _defaults.$elements[key] = $(value);
        });
    }

    function update(index){
        if(_defaults.isAnimate){
            return false;
        }

        _defaults.isAnimate = true;

        setTimeout(function(){
            _defaults.isAnimate = false;
        }, 300);

        _defaults.$elements.active = _defaults.$elements.slides.filter('.active');
        _defaults.$elements.previous = _defaults.$elements.slides.filter('.previous');
        _defaults.$elements.next = _defaults.$elements.slides.filter('.next');

        if(_defaults.action == 'previous'){
            _defaults.$elements.slides.eq(index).removeClass('previous').addClass('active');
            _defaults.$elements.next.removeClass('next').addClass('previous');
            _defaults.$elements.active.removeClass('active').addClass('next');
        }

        if(_defaults.action == 'next'){
            _defaults.$elements.slides.eq(index).removeClass('next').addClass('active');
            _defaults.$elements.previous.removeClass('previous').addClass('next');
            _defaults.$elements.active.removeClass('active').addClass('previous');
        }
    }

    var moduleApi = function moduleApi(){
        this.method = function(){

        };
    };

    Module.prototype = new moduleApi();

    return Module;
});
